export default __webpack_public_path__ + "static/media/15t.344ce92a.jpg";